module.exports = __webpack_public_path__ + "img/fortePayment.20bd2ae3.png";